import React, { useState } from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from "jwt-decode";

const Login = ({ onLogin }) => {
    // Removed local user state as it is lifted to App.js
    const [error, setError] = useState(null);

    const onSuccess = (credentialResponse) => {
        try {
            const decoded = jwtDecode(credentialResponse.credential);
            console.log('Login Success:', credentialResponse);
            console.log('User Info:', decoded);
            // Pass user data up to parent instead of setting local state
            if (onLogin) {
                onLogin(decoded);
            }
            setError(null);
        } catch (err) {
            setError("Failed to process login information.");
            console.error(err);
        }
    };

    const onFailure = () => {
        console.log('Login Failed');
        setError("Google Login Failed. Please try again.");
    };

    return (
        <>
            {error && <div className="error-message" style={{ color: '#ef4444', marginBottom: '16px' }}>{error}</div>}
            <div className="google-login-wrapper" style={{ display: 'flex', justifyContent: 'center' }}>
                <GoogleLogin
                    onSuccess={onSuccess}
                    onError={onFailure}
                    useOneTap
                />
            </div>
        </>
    );
};

export default Login;
